// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__xPVsk","title":"FrontImage_title__3Ff2k"};